/**
 * Ціноутворення кампанії розпродажу.
 *
 * У базі Price — це справжня рекомендована ціна (RRP), та сама, що діяла
 * на сайті до кампанії. Ціну зі знижкою рахуємо тут, тією самою формулою,
 * яка формує фід для Rozetka, щоб цифри на сайті й на маркетплейсі збігались.
 *
 * Формула: беремо -40%, потім опускаємось до найближчого "красивого"
 * закінчення, щоб змінилась перша цифра й перетнувся круглий поріг.
 * 4200 -> 2499, 2200 -> 1299, 800 -> 449. Реальна знижка виходить 40-44%.
 */
export const CAMPAIGN_DISCOUNT = 0.4;

export const campaignPrice = (rrp: number): number => {
  const target = rrp * (1 - CAMPAIGN_DISCOUNT);
  const step = target >= 1000 ? 100 : 50;
  return Math.floor(target / step) * step - 1;
};

export const discountPercent = (rrp: number): number =>
  Math.round((1 - campaignPrice(rrp) / rrp) * 100);

export const savings = (rrp: number): number => rrp - campaignPrice(rrp);

/** 2499 -> "2 499" */
export const formatPrice = (value: number): string =>
  Math.round(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
